import { IDistributionDealsFilters, IDistributionDeal, IDealForDrawdownStoreItem, IDealForDrawdownResponseItem } from './interfaces';
import { ThunkAPI } from '../../../rootReducer';
import { CORE_SERVICES, HttpMethods } from '../../../../services/api';
import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../../../services/apiAsyncThunkCreator';
import { showErrorMessage } from '../../../notifications';

export interface IFetchDistributionDealsResponse {
  docs: IDistributionDeal[];
  totalDocs: number;
  page: number;
}

export interface IFetchHasDistributionDealsResponse {
  exists: boolean;
}

export const fetchDistributionDeals: AsyncThunk<IFetchDistributionDealsResponse, IDistributionDealsFilters, ThunkAPI> = createAsyncThunk(
  'creditPoolDistribution/fetchDistributionDeals',
  async (data: IDistributionDealsFilters, thunk) => {
    try {
      return await basicApiAsyncThunkCreator<IFetchDistributionDealsResponse, undefined>({
        endpoint: `credit-pool/deals-with-credits/${data.accountId}?page=${data.page}&limit=${data.limit}`,
        microservice: CORE_SERVICES.CREDITS_SERVICE,
        authenticated: true,
        method: HttpMethods.Get,
        contentType: 'application/json'
      })(undefined, thunk);
    } catch (err) {
      thunk.dispatch(showErrorMessage('An error occurred fetching the distribution deals.'));
      return thunk.rejectWithValue(err);
    }
  }
);

export const fetchHasDistributionDeals: AsyncThunk<IFetchHasDistributionDealsResponse, string, ThunkAPI> = createAsyncThunk(
  'creditPoolDistribution/fetchHasDistributionDeals',
  async (accountId: string, thunk) => {
    try {
      return basicApiAsyncThunkCreator<IFetchHasDistributionDealsResponse, undefined>({
        endpoint: `credit-pool/has-distribution-deals/${accountId}`,
        microservice: CORE_SERVICES.CREDITS_SERVICE,
        authenticated: true,
        method: HttpMethods.Get,
        contentType: 'application/json'
      })(undefined, thunk);
    } catch (err) {
      return thunk.rejectWithValue(err);
    }
  }
);

type AccountId = string;
export const fetchDealsForDrawdownByAccountId: AsyncThunk<IDealForDrawdownStoreItem[], AccountId, ThunkAPI> = createAsyncThunk(
  'draw-down/deals',
  async (accountId, thunk) => {
    const response = await basicApiAsyncThunkCreator<IDealForDrawdownResponseItem[], void>({
      endpoint: `deals/draw-down/${accountId}`,
      microservice: CORE_SERVICES.CREDITS_SERVICE,
      authenticated: true,
      method: HttpMethods.Get
    })(undefined, thunk);
    return response;
  }
);
